import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  close: {
    padding: theme.spacing(0.5),
  },
}));
